// extracted by mini-css-extract-plugin
export default {"input":"fees-input_input__dBnRl","feesWrapper":"fees-input_feesWrapper__cwGP9"};